<template>
  <v-card
    :class="cardClasses"
    :disabled="isDisabled"
    :hover="!isDisabled"
    :to="isDisabled ? '' : event.to || `/events/${event.id}`"
  >
    <v-img
      :aspect-ratio="aspectRatio"
      :lazy-src="event.image.thumbnail"
      :position="event.image.position"
      :src="event.image.url"
    >
      <v-row class="fill-height" align="stretch" justify="space-between" no-gutters>
        <v-col class="pa-2" v-if="eventType && !eventType.hidden">
          <v-chip label
            :color="eventType.color"
            class="elevation-2"
            :text-color="eventType.textColor || 'white'"
          >
            {{eventType.label}}
          </v-chip>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="pa-2" cols="auto">
          <v-card width="80" class="date pa-2" v-if="!event.hideDate && event.startAt">
            <v-row class="day" justify="center" no-gutters>{{formatDay(event.startAt)}}</v-row>
            <v-row class="year mt-0" justify="center" no-gutters>{{formatYear(event.startAt)}}</v-row>
            <v-row class="time" justify="center" no-gutters>{{formatTime(event.startAt)}}</v-row>
          </v-card>
          <!-- <v-card width="80" class="date pa-2" v-if="!event.hideDate && event.endAt">
            <v-row justify="space-between" no-gutters>
              <v-col>
                <v-row class="day" justify="center" no-gutters>{{formatDay(event.startAt)}}</v-row>
                <v-row class="year mt-0" justify="center" no-gutters>{{formatYear(event.startAt)}}</v-row>
                <v-row class="time-range" justify="center" no-gutters>to</v-row>
                <v-row class="day" justify="center" no-gutters>{{formatDay(event.endAt)}}</v-row>
                <v-row class="year mt-0" justify="center" no-gutters>{{formatYear(event.endAt)}}</v-row>
              </v-col>
            </v-row>
          </v-card> -->
        </v-col>
        <v-col cols="12" align-self="end" v-if="event.title">
          <v-row class="pb-2">
            <v-col cols="auto">
              <v-card tile class="card-title font-weight-bold py-2 px-4">
                {{event.title}}
              </v-card>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-img>
  </v-card>
</template>

<script>
import moment from 'moment'
import { eventTypes } from '@/views/events/events'
import {
  VCard,
  VChip,
  VCol,
  VImg,
  VRow,
  VSpacer,
} from 'vuetify/lib'

export default {
  components: {
    VCard,
    VChip,
    VCol,
    VImg,
    VRow,
    VSpacer,
  },
  computed: {
    cardClasses() {
      return this.$vuetify.breakpoint.xsOnly ? ['card-sm'] : []
    },
    eventType() {
      return eventTypes.find((eventType) => eventType.value === this.event.type)
    },
    imgHeight() {
      return this.$vuetify.breakpoint.xsOnly ? 200 : 280
    },
    isDisabled() {
      return this.disabled || this.event.disabled
    }
  },
  methods: {
    formatDay(timestamp) {
      return moment(timestamp.toDate()).format('D MMM')
    },
    formatTime(timestamp) {
      const time = moment(timestamp.toDate())

      return time.minutes() ? time.format('h:mma') : time.format('ha')
    },
    formatYear(timestamp) {
      return moment(timestamp.toDate()).format('YYYY')
    }
  },
  props: {
    aspectRatio: {
      default: '1',
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    event: Object,
  }
}
</script>

<style scoped>
.v-chip {
  margin: 0;
  text-transform: uppercase;
}

.v-card__title {
  align-items: center;
  justify-content: center;
}

.v-card[disabled="disabled"] {
  opacity: 0.6;
}

.card-sm {
  font-size: 15px;
}

.card-sm .day {
  font-size: 16px;
}

.day {
  font-weight: bold;
  font-size: 16px;
  text-transform: uppercase;
}

.year {
  font-size: 13px;
  text-transform: uppercase;
}

.time {
  border-top: 1px solid gray;
  margin-top: 5px !important;
  padding-top: 5px;
  font-size: 13px;
}

.time-range {
  font-size: 13px;
  margin: 0;
  padding: 0;
}
</style>
